<template>
    <a :href="url" class="card" :class="{ 'card--featured flex-column flex-sm-row': featured }">
        <div class="card-img-top__wrapper" :data-explore-text="exploreLabel">
            <img v-if="image"
                 :src="image"
                 :alt="imageAlt" @mouseover="fade(title, true)" @mouseout="fade(title, false)">
        </div> 
        <div class="card-body" @mouseover="fade(title, true)" @mouseout="fade(title, false)">
            <h5 class="card-title">{{ title }}</h5>
            <h6 v-if="isRooms && theme == 'riviera'" class="card-subtitle detail">{{ category }}</h6>
            <h6 v-if="!isRooms && theme == 'riviera'" class="card-subtitle detail">{{ guideFor }}</h6>
            <hr v-if="isRooms" />
            <ul class="card-text">
                <li v-if="occupancyLabel">{{ occupancyLabel }}</li>
                <li v-if="dimensionsLabel">{{ dimensionsLabel }}</li>
                <li v-if="poolLabel && theme == 'riviera'">{{ poolLabel }}</li>
                <li v-if="roomView && theme == 'riviera'">{{ roomView }}</li>
            </ul>
        </div>

    </a>
</template>

<script>
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        props: {

            theme: {
                type: String,
                required: true,
            },

            listingType: {
                type: String,
                required: true,
            },

            title: {
                type: String,
                required: true,
            },

            url: {
                type: String,
                required: true,
            },

            image: {
                type: String,
                required: true,
            },

            imageAlt: {
                type: String,
                required: true,
            },

            category: {
                type: String,
                required: false,
            },

            roomView: {
                type: String,
                required: false,
            },

            poolLabel: {
                type: String,
                required: false,
            },

            occupancyLabel: {
                type: String,
                required: false,
            },

            dimensionsLabel: {
                type: String,
                required: false,
            },

            exploreLabel: {
                type: String,
                required: false,
            },

            guideFor: {
                type: String,
                required: false,
            },

            guideTime: {
                type: String,
                required: false,
            },

            featured: {
                type: Boolean,
                required: true,
                default: false,
            }
        },

        computed: {
            isRooms() {
                return this.listingType == 'rooms'
            }
        },

        methods: {
            ...mapMutations('rooms', [
                'setHoveredItem',
            ]),

            fade: function (itemTitle, isHovered) {
                this.setHoveredItem({ itemTitle, isHovered });
            }
        }
    }
</script>